import React, { useState } from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import CaseTypeWizard from './CaseTypeWizard';
import { Size } from '../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	workplaceId: string;
	isOnlyOneRoot: boolean;
	onRedirectToShifts: () => void;
	reloadList: () => void;
	caseTypeId?: string;
}

const CaseTypeWizardModal: React.FC<Props> = props => {
	const [closeWithReload, setCloseWithReload] = useState(false);

	const handleClose = (forceReload: boolean = false) => {
		if (closeWithReload || forceReload) {
			props.reloadList();
		}
		props.onClose();
	};

	return (
		<BaseModal
			{...props}
			onClose={handleClose}
			title={
				props.caseTypeId
					? 'component.caseType.editCaseType'
					: 'component.caseType.addCaseType'
			}
			size={Size.LG}>
			<CaseTypeWizard
				workplaceId={props.workplaceId}
				isOnlyOneRoot={props.isOnlyOneRoot}
				onRedirectToShifts={props.onRedirectToShifts}
				caseTypeId={props.caseTypeId}
				onClose={handleClose}
				onFirstStepSuccess={() => setCloseWithReload(true)}
			/>
		</BaseModal>
	);
};

export default CaseTypeWizardModal;
